import { render, staticRenderFns } from "./DailyFerryEdit.vue?vue&type=template&id=08308ca2&scoped=true"
import script from "../../controllers/daily_ferry/daily-ferry-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/daily_ferry/daily-ferry-edit.js?vue&type=script&lang=js&external"
import style0 from "@/assets/css/daily-ferry-edit.css?vue&type=style&index=0&id=08308ca2&prod&scoped=true&lang=css&external"
import style1 from "./DailyFerryEdit.vue?vue&type=style&index=1&id=08308ca2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08308ca2",
  null
  
)

export default component.exports